import { fetch } from 'reactor/components';
import { C } from 'common';
import onLogout from './onLogout';

const { FETCH_PROPS } = C;

export default async (authorization) => {
  const agency = await fetch({
    ...FETCH_PROPS,
    method: 'GET',
    service: 'agency',
    headers: { authorization },
  }).catch(() => {
    onLogout();
  });

  return agency;
};
